import React from 'react';

import { useModalsV2Context } from 'src/hooks/shared';

export const ModalsV2Root: React.FC = () => {
  const { state } = useModalsV2Context();

  const modals = React.useMemo(() => {
    return Object.entries(state).map(([, modal]) => {
      if (modal?.component) {
        const Component = modal.component;
        return <Component key={modal.props.id} {...modal.props} />;
      }
      return null;
    });
  }, [state]);

  return <React.Fragment>{modals}</React.Fragment>;
};
